import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { toast, ToastContainer } from 'react-toastify'

import CustomLink from '../../../components/_atoms/CustomLink/CustomLink'
import SalesButton from '../../../components/_atoms/SalesButton/SalesButton'
import SalesText from '../../../components/_atoms/SalesText/SalesText'
import { colors, fontSizes, fontWeights } from '../../../constants/salesStyles'
import createUserTaskResult from '../../../modules/redux/tasksService/CreateUserTaskResult'
import updateUserTaskResult from '../../../modules/redux/tasksService/UpdateUserTaskResult'
import { useDispatch } from '../../../modules/store/customDispatch'
import { useSelector } from '../../../modules/store/customSelector'
import OnboardingLayout from '../OnboardingLayout/OnboardingLayout'

import styles from './styles.module.scss'

const PAYMENT_URL = 'https://vas.partsauto.expert/product/import/'

const DownloadFromFile = () => {
    const dispatch = useDispatch()
    const onboardingTask = useSelector(state => state.userData.tasksInfo?.onboarding)
    const savedImportUrl = onboardingTask?.result?.import_url || ''
    const [importUrl, setImportUrl] = useState(savedImportUrl)
    const [isPriceListSent, setIsPriceListSent] = useState(
        onboardingTask?.result?.step === 'autoimport' && Boolean(savedImportUrl),
    )
    const [isSubmitting, setIsSubmitting] = useState(false)

    useEffect(() => {
        if (savedImportUrl) {
            setImportUrl(savedImportUrl)
            setIsPriceListSent(onboardingTask?.result?.step === 'autoimport')
        }
    }, [onboardingTask?.result?.step, savedImportUrl])

    const handleOnboardingDone = async () => {
        const preparedImportUrl = importUrl.trim()

        if (!preparedImportUrl) {
            toast.error('Укажите ссылку на файл прайс-листа')
            return
        }

        setIsSubmitting(true)

        try {
            if (onboardingTask) {
                await dispatch(
                    updateUserTaskResult({
                        code: 'onboarding',
                        userTaskId: onboardingTask.id,
                        status: 'done',
                        result: {
                            step: 'autoimport',
                            import_url: preparedImportUrl,
                        },
                    }),
                )
            } else {
                await dispatch(
                    createUserTaskResult({
                        code: 'onboarding',
                        status: 'done',
                        result: {
                            step: 'autoimport',
                            import_url: preparedImportUrl,
                        },
                    }),
                )
            }
            setIsPriceListSent(true)
            toast.success('Ссылка отправлена. Теперь оплатите услугу загрузки.')
        } catch (error) {
            toast.error('Не удалось отправить ссылку')
            console.error('Ошибка при отправке ссылки', error)
        } finally {
            setIsSubmitting(false)
        }
    }

    const handleBtnClick = () => {
        handleOnboardingDone()
    }

    const handleChangeUrlClick = () => {
        setIsPriceListSent(false)
    }

    return (
        <OnboardingLayout>
            <div className="col-8">
                <ToastContainer position="bottom-center" autoClose={5000} />
                <SalesText
                    text={'Загрузить запчасти из файла'}
                    fontWeight={fontWeights.bold}
                    fontSize={fontSizes.xxl}
                />
                {isPriceListSent ? (
                    <div style={{ marginRight: '100px' }}>
                        <SalesText
                            text={`Мы приняли ссылку на ваш прайс-лист в работу и загрузим запчасти в течение двух дней после оплаты.`}
                            fontWeight={fontWeights.normal}
                            fontSize={fontSizes.xs}
                            marginTopPixels={28}
                        />
                        <CustomLink
                            text={importUrl}
                            href={importUrl}
                            target={'_blank'}
                            marginTop={18}
                            marginLeft={0}
                            arrowIcon
                        />
                        <SalesButton
                            backgroundColor={colors.transparent}
                            borderColor={colors.blue}
                            borderWidth={1}
                            paddingVerticalPixels={10}
                            paddingHorizontalPixels={0}
                            className="justify-content-center"
                            onClick={handleChangeUrlClick}
                        >
                            <SalesText text={'Изменить ссылку'} color={colors.blue} fontSize={fontSizes.xs} />
                        </SalesButton>
                        <SalesText
                            text={`Чтобы работа началась, необходимо оплатить услугу загрузки файла.`}
                            fontWeight={fontWeights.normal}
                            fontSize={fontSizes.xs}
                            marginTopPixels={28}
                        />
                        <CustomLink
                            text={'Перейти к оплате'}
                            href={PAYMENT_URL}
                            target={'_blank'}
                            marginTop={10}
                            marginLeft={0}
                            arrowIcon
                        />
                    </div>
                ) : (
                    <div style={{ marginRight: '80px' }}>
                        <SalesText
                            text={`Добавьте ссылку на ваш прайс-лист в xml формате Авито или Дром или пришлите нам ваш
                        прайс в формате эксель. Мы автоматически загрузим его в ваш аккаунт.`}
                            fontWeight={fontWeights.normal}
                            fontSize={fontSizes.xs}
                            marginTopPixels={28}
                        />
                        <SalesText
                            text={'Стоимость загрузки файла запчастей составляет 5 тыс руб'}
                            marginTopPixels={40}
                            fontWeight={fontWeights.normal}
                            fontSize={fontSizes.xs}
                        />

                        <Form.Group controlId="formFile" className={styles.customFormGroup}>
                            <Form.Control
                                type="url"
                                placeholder="Укажите ссылку на файл прайс-листа"
                                value={importUrl}
                                onChange={e => setImportUrl(e.target.value)}
                            />
                            <CustomLink
                                text={'Где взять файл автозагрузки авито'}
                                href={'https://partsauto.expert/find-autoload-file-avito'}
                                target={'_blank'}
                                marginTop={14}
                                marginLeft={0}
                            />
                        </Form.Group>

                        <SalesButton
                            backgroundColor={colors.blue}
                            paddingVerticalPixels={10}
                            paddingHorizontalPixels={36}
                            marginTopPixels={24}
                            className="justify-content-center"
                            onClick={handleBtnClick}
                            disabled={isSubmitting}
                        >
                            <SalesText
                                text={isSubmitting ? 'Отправляем...' : 'Отправить ссылку'}
                                color={colors.white}
                                fontSize={fontSizes.l}
                            />
                        </SalesButton>
                    </div>
                )}
            </div>
        </OnboardingLayout>
    )
}

export default DownloadFromFile
